import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PopoverModule } from 'ngx-bootstrap/popover';
import {
  isShipCollateralItem,
  isVehicleCollateralItem,
  ShipCollateralItemEntity,
  VehicleCollateralItemEntity,
} from '../../utils/collateral-item.utils';
import { CollateralItemComponent } from './collateral-item.component';

@Component({
  selector: 'nk-collateral-items',
  templateUrl: './collateral-items.component.html',
  imports: [TranslateModule, PopoverModule, CollateralItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollateralItemsComponent {
  public printVersion = input(false);
  public items = input.required<(ShipCollateralItemEntity | VehicleCollateralItemEntity)[], unknown[]>({
    transform: (items: unknown[]) =>
      items?.filter(
        (item): item is ShipCollateralItemEntity | VehicleCollateralItemEntity =>
          isShipCollateralItem(item as ShipCollateralItemEntity | VehicleCollateralItemEntity) ||
          isVehicleCollateralItem(item as ShipCollateralItemEntity | VehicleCollateralItemEntity),
      ) ?? [],
  });
}
